<template>
  <div class="fund-allocation-content">
    <el-input
      v-model="companyName"
      placeholder="搜索子公司名称..."
      clearable
      class="search-input"
      prefix-icon="el-icon-search"
    />
    <el-table
      :data="list"
      border
      stripe
      style="width: 100%; margin-top: 16px"
      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
    >
      <el-table-column prop="companyName" label="子公司名称" min-width="120" />

      <el-table-column
        prop="allocatedAmount"
        label="总分配金额"
        width="120"
        align="right"
      >
        <template slot-scope="scope">
          {{ formatAmount(scope.row.allocatedAmount) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="availableAmount"
        label="可用余额"
        width="120"
        align="right"
      >
        <template slot-scope="scope">
          {{ formatAmount(scope.row.availableAmount) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="usedAmount"
        label="已用金额"
        width="120"
        align="right"
      >
        <template slot-scope="scope">
          {{ formatAmount(scope.row.usedAmount) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="当前状态"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status === 1 ? 'success' : 'danger'"
            size="small"
            effect="plain"
          >
            {{ scope.row.status === 1 ? "正常" : "冻结" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="资金分配"
            placement="top"
          >
            <el-button
              type="primary"
              size="mini"
              circle
              icon="el-icon-circle-plus-outline"
              @click="handleAllocate(scope.row)"
            />
          </el-tooltip>
          <el-tooltip
            class="item op-tooltip-gap"
            effect="dark"
            content="资金回收"
            placement="top"
          >
            <el-button
              type="primary"
              size="mini"
              circle
              icon="el-icon-refresh-left"
              @click="handleAllocateReclaim(scope.row)"
            />
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      v-show="total > 0"
      :current-page.sync="pageNum"
      :page-size="pageSize"
      :total="total"
      layout="total, prev, pager, next, jumper"
      background
      style="margin-top: 16px; text-align: right"
      @current-change="handlePageChange"
    />
    <!-- 资金分配 -->
    <el-dialog
      append-to-body
      modal-append-to-body
      title="分配资金"
      :visible.sync="showDetailDialog"
      :close-on-click-modal="false"
      width="30%"
      @close="onDialogClose"
    >
      <div class="allocation-form">
        <div class="form-row">
          <span class="form-label">子公司名称</span>
          <span class="form-value form-value-bold">{{
            currentRow.companyName
          }}</span>
        </div>
        <div class="form-row">
          <span class="form-label">可分配金额</span>
          <span class="form-value form-value-amount">{{
            formatAmount(availableBalance)
          }}</span>
        </div>
        <div class="form-row">
          <span class="form-label">分配金额</span>
          <div class="form-input-wrap">
            <el-input
              v-model="allocationAmount"
              placeholder="请输入分配金额"
              clearable
              type="number"
              @input="onAllocationInput"
            />
            <div class="form-hint">
              最大可分配金额:
              <b> {{ formatAmount(availableBalance) }}</b>
            </div>
          </div>
        </div>
      </div>
      <div class="btn_wrap">
        <el-button @click="showDetailDialog = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmAllocate"
          >确认分配</el-button
        >
      </div>
    </el-dialog>
    <!-- 资金回收 -->
    <el-dialog
      append-to-body
      modal-append-to-body
      title="回收资金"
      :visible.sync="showReclaimFundsDialog"
      :close-on-click-modal="false"
      width="30%"
      @close="onDialogClose"
    >
      <div class="allocation-form">
        <div class="form-row">
          <span class="form-label">子公司名称</span>
          <span class="form-value form-value-bold">{{
            currentRow.companyName
          }}</span>
        </div>
        <div class="form-row">
          <span class="form-label">可回收金额</span>
          <span class="form-value form-value-amount">{{
            formatAmount(currentRow.availableAmount)
          }}</span>
        </div>
        <div class="form-row">
          <span class="form-label">回收金额</span>
          <div class="form-input-wrap">
            <el-input
              v-model="allocationAmount"
              placeholder="请输入回收金额"
              clearable
              type="number"
              @input="onAllocationInput"
            />
            <div class="form-hint">
              最大可回收金额:
              <b> {{ formatAmount(currentRow.availableAmount) }}</b>
            </div>
          </div>
        </div>
      </div>
      <div class="btn_wrap">
        <el-button @click="showReclaimFundsDialog = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmReclaim"
          >确认回收</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { debounce, getUUID } from "@/utils";
import {
  getSubsidiaryAccountList,
  allocateFunds,
  reclaimFunds
} from "@/api/shipment";
export default {
  name: "FundAllocation",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    partyCode: {
      type: String,
      default: ""
    },
    availableBalance: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showReclaimFundsDialog: false,
      showDetailDialog: false,
      companyName: "",
      currentRow: {
        subsidiaryName: "",
        availableBalance: 0
      },
      allocationAmount: "",
      list: [],
      pageNum: 1,
      pageSize: 15,
      total: 0
    };
  },

  watch: {
    partyCode: {
      handler() {
        this.pageNum = 1;
        this.getSubsidiaryAccountListApi();
      },
      immediate: true
    },
    companyName: debounce(function() {
      this.pageNum = 1;
      this.getSubsidiaryAccountListApi();
    }, 500)
  },
  methods: {
    getSubsidiaryAccountListApi() {
      getSubsidiaryAccountList({
        partyCode: this.partyCode,
        companyName: this.companyName,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(res => {
        this.list = res.data.records;
        this.total = res.data.total;
      });
    },
    handlePageChange(page) {
      this.pageNum = page;
      this.getSubsidiaryAccountListApi();
    },
    formatAmount(val) {
      if (val == null || val === "") return "¥0.00";
      const num = Number(val);
      if (isNaN(num)) return "¥0.00";
      return (
        "¥" +
        num.toLocaleString("zh-CN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      );
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.companyName = "";
    },
    handleAllocateReclaim(row) {
      this.currentRow = row;
      this.allocationAmount = "";
      this.showReclaimFundsDialog = true;
    },
    handleAllocate(row) {
      this.currentRow = row;
      this.allocationAmount = "";
      this.showDetailDialog = true;
    },
    onDialogClose() {
      this.allocationAmount = "";
    },
    onAllocationInput(val) {
      const num = parseFloat(val);
      if (
        !isNaN(num) &&
        this.currentRow.availableBalance != null &&
        num > this.currentRow.availableBalance
      ) {
        this.$nextTick(() => {
          this.allocationAmount = String(this.currentRow.availableBalance);
        });
      }
    },
    handleConfirmReclaim() {
      const num = parseFloat(this.allocationAmount);
      if (this.allocationAmount === "" || isNaN(num) || num <= 0) {
        this.$message.warning("请输入有效的回收金额");
        return;
      }
      if (num > this.currentRow.availableAmount) {
        this.$message.warning("可回收金额不能超过最大可回收金额");
        return;
      }
      reclaimFunds({
        bizNo: getUUID(),
        code: this.currentRow.code,
        amount: this.allocationAmount
      }).then(res => {
        if (res.status === 0) {
          this.$message.success("回收成功");
          this.$emit("allocateSuccess");
          this.getSubsidiaryAccountListApi();
        }
      });
      this.showReclaimFundsDialog = false;
    },
    handleConfirmAllocate() {
      const num = parseFloat(this.allocationAmount);
      if (this.allocationAmount === "" || isNaN(num) || num <= 0) {
        this.$message.warning("请输入有效的分配金额");
        return;
      }
      if (num > this.availableBalance) {
        this.$message.warning("分配金额不能超过可分配金额");
        return;
      }
      allocateFunds({
        bizNo: getUUID(),
        code: this.currentRow.code,
        amount: this.allocationAmount
      }).then(res => {
        if (res.status === 0) {
          this.$message.success("分配成功");
          this.$emit("allocateSuccess");
          this.getSubsidiaryAccountListApi();
        }
      });
      this.showDetailDialog = false;
    }
  }
};
</script>

<style scoped lang="scss">
.btn_wrap {
  width: 100%;
  text-align: right;
  margin-top: 10px;
}
.fund-allocation-content {
  padding: 20px;
  .op-tooltip-gap {
    margin-left: 8px;
  }
}
.search-input {
  width: 100%;
}
.search-input ::v-deep .el-input__inner {
  border-radius: 4px;
}

.allocation-form {
  .form-row {
    margin-bottom: 20px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  .form-label {
    display: block;
    font-size: 14px;
    color: #606266;
    margin-bottom: 8px;
  }
  .form-value {
    font-size: 18px;
    color: #303133;
    font-weight: bold;
    &.form-value-bold {
      font-weight: 600;
    }
    &.form-value-amount {
      font-weight: 600;
      color: #67c23a;
    }
  }
  .form-input-wrap {
    .form-hint {
      font-size: 14px;
      color: #909399;
      margin-top: 6px;
    }
  }
}
.dialog-footer {
  text-align: right;
}
</style>
